import saveAs from 'file-saver';
import { events } from './events';
import { Module } from './framework/module';

export class DownloadModule extends Module {
  private lastEvent: { blob: Blob; filename: string } | undefined;

  async onInit() {
    events.on('download', (event) => this.onDownload(event));
    events.on('download-file', () => this.onDownloadFile());
  }

  private onDownload({ blob, filename }: { blob: Blob; filename: string }) {
    this.lastEvent = { blob, filename };
    saveAs(blob, filename);

    events.emit('downloaded-file', { type: 'file' });
  }

  private onDownloadFile() {
    if (this.lastEvent) {
      saveAs(this.lastEvent.blob, this.lastEvent.filename);
    }
  }
}
